import { createContext } from 'react';
import { defaultTheme } from '../../../theme';

export const KliThemeContext = createContext(defaultTheme);
